import { CopyTypeKey } from "us.collection.admin/interfaces";

export const COPY_TYPE_LABELS: Record<CopyTypeKey, string> = {
  nonPrinting: "US.COLLECTION.ADMIN:NON_PRODUCTION_DAYS.NON_PRINTING",
  nonSms: "US.COLLECTION.ADMIN:NON_PRODUCTION_DAYS.NON_SMS",
  nonEmail: "US.COLLECTION.ADMIN:NON_PRODUCTION_DAYS.NON_EMAIL",
  nonEhf: "US.COLLECTION.ADMIN:NON_PRODUCTION_DAYS.NON_EHF",
};

export const COPY_DATE_FORMAT = "MM/DD/YYYY h:mm:ss A";
